import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { GridColumn, CrawfordSpinnerService, CrawfordSnackbarService, DateFormat } from 'crawford-shell';
import { CommunicationService } from '../../communication/communication.service';
import { FormGroup, FormControl } from '@angular/forms';
import { global } from '../../app.settings';
import { ReportService } from '../report.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-event-report',
  templateUrl: './event-report.component.html',
  styleUrls: ['./event-report.component.scss']
})
export class EventReportComponent implements OnInit {
  displayColumns: GridColumn[];
  public sortingSettings: any = {
    columns: [{ field: 'date', direction: 'descending' }]
  };

  gridData: any;
  crawfordRef: string;
  group = new FormGroup(
    {
      'reportType': new FormControl(),
      'printOrder': new FormControl(),
      'notify': new FormControl(),
      'email': new FormControl()
    }
  );
  public reportTypes = [
    { id: 1, name: 'Print All Events' },
    { id: 2, name: 'Print Selected Events' },
    { id: 3, name: 'Print All Events and Attachments' },
    { id: 4, name: 'Print Selected Events and Attachments' }
  ];

  public printOrders = [
    { id: 1, name: 'Earliest first' },
    { id: 2, name: 'Latest first' }
  ];

  @ViewChild('templateIcon') templateIconRef: TemplateRef<any>;

  constructor(private reportService: ReportService,
    private communicationService: CommunicationService,
    private spinnerService: CrawfordSpinnerService,
    private snackbarService: CrawfordSnackbarService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      if (params.id) {
        this.crawfordRef = params.id;
      }
    });

    const dateFormat: DateFormat = {
      type: 'date',
      format: global.dateTimeFormat
    };
    this.displayColumns = [
      new GridColumn('id', 'EventId', { visible: false }),
      new GridColumn('name', 'Event'),
      new GridColumn('documentName', 'Document'),
      new GridColumn('documentType', 'Document Type', { template: this.templateIconRef }),
      new GridColumn('party', 'Party'),
      new GridColumn('date', 'Date', { type: 'date', format: dateFormat }),
      new GridColumn('category', 'Category'),
      new GridColumn('additionalInfo', 'Additional Info', { visible: false, showInColumnChooser: false })
    ];
    this.createGridData();
  }

  createGridData() {
    this.reportService.getEvents(this.crawfordRef).subscribe(events => {
      if (events) {
        events.forEach((event) => {
          event.iconClass = this.updateDocumentTypeToIcon(event.documentType);
        });
        this.gridData = events;
      }
    });
  }
  onRowDataBound($event): void {
    const data = $event.data;
    const row = $event.row;

    if (data.documentName) {
      row.classList.add('selectable-row');
    }
  }

  onDataBound($event: any): void {
    this.spinnerService.hide('pageSpinner');
  }

  onActionFailure($event): void {
    this.snackbarService.displayErrorMessage($event.error);
    this.spinnerService.hide('pageSpinner');
  }

  public updateDocumentTypeToIcon(documentType: string): string {
    if (!documentType) {
      return null;
    }
    const types = this.communicationService.documentType;
    return types[documentType.toLowerCase()] ? types[documentType.toLowerCase()].icon : types['default'].icon;
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/report/event-report/event-report.component.ts